import { PriceListSearch } from "@feature/price-list";
import {NotificationsContext} from "../ui-components/Notifications";
import { useContext, useState} from "react";
import { useIntl } from "react-intl";
import Container from "@ui-components/Container";

const PublicPriceList = () => {
  const intl = useIntl();
  const { push } = useContext(NotificationsContext);
  const [startSearch, setStartSearch] = useState(false);
  const [canSearch, setCanSearch] = useState(false);
  const [priceListData, setPriceListData] = useState({});

  return <>
    <Container>
        <PriceListSearch
          intl={intl}
          publicMode={true}
          priceListData={priceListData}
          setPriceListData={setPriceListData}
          canSearch={canSearch}
          setCanSearch={setCanSearch}
          push={push}
        />
    </Container>
  </>
}

export default PublicPriceList;